@import (reference) '../../../constants/spacing.module.less';

.order-details-sidebar-and-side-panel-container {
  display: flex;
  flex-flow: row nowrap;
}

.order-details-sidebar {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-16;
  padding: @space-16;
  border-right: solid 1px var(--default--border-color--10);
}

.divider {
  border-color: var(--default--border-color--10);
}

.icon {
  height: 16px;
  width: 16px;
}
